// Core
import React, { useState } from "react";

// Styles
import "./styles.scss";

const PhotoUpload = ({
  title = "Upload Photo",
  photo,
  onPhotoUpload,
  required,
}) => {
  const [hoverStyles, setHoverStyles] = useState({});

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && onPhotoUpload) {
      onPhotoUpload(file);
    }
  };

  const handleMouseMove = (e) => {
    const { offsetX, offsetY, target } = e.nativeEvent;
    const { clientWidth, clientHeight } = target;

    // Calculate transform origin based on cursor position
    const xPercent = (offsetX / clientWidth) * 100;
    const yPercent = (offsetY / clientHeight) * 100;

    setHoverStyles({
      transformOrigin: `${xPercent}% ${yPercent}%`,
    });
  };

  const handleRemovePhoto = () => {
    onPhotoUpload(null);
    document.querySelector(".file-input").value = null;
  };

  return (
    <div className="photo-upload-container">
      <h2 className="upload-title">
        {title}
        {required && " *"}{" "}
      </h2>
      <label className="upload-button">
        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          className="file-input"
        />
        Upload
      </label>
      {photo && (
        <div className="photo-preview">
          <div className="photo-wrapper">
            <img
              src={photo}
              alt="Uploaded"
              className="uploaded-photo"
              style={hoverStyles}
              onMouseMove={handleMouseMove} // Dynamic zoom origin on hover
            />
          </div>
          <button onClick={handleRemovePhoto} className="remove-button">
            Remove
          </button>
        </div>
      )}
    </div>
  );
};

export default PhotoUpload;
